//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {VBModal} from 'bootstrap-vue'
import ProfileData from '~/components/profile/mixins/ProfileData'

import Vue from 'vue'
Vue.directive('b-modal', VBModal)

export default {

    name: 'ProfileHeader',

    mixins: [ProfileData],

    props: {
        company: {
        },
        destination: {
        },
        internalVisit: {
        },
    },

    mounted() {

        if(process.client) {
            if(this.company.publish === false || this.company.isApproved === false) {
                this.$bus.$emit('alert/show', 'This profile is not published yet. Only you can see this page.', 30, 'check', 'warning')
            }
        }

    },

}

